import request from "@/utils/request";

/**
 * 获取银行归属接口
 *
 * @description 根据银行卡号获取银行归属及图片
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBankFrom(playload, config) {
  return request({
    url: "/api/v2/user/queryBankFrom",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 绑定用户银行卡信息
 *
 * @description 提现时绑定用户卡号
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function bandingBankInfo(playload) {
  return request({
    url: "/api/v2/user/bandingBankInfo",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 获取用户银行卡信息
 *
 * @description 提现时获取员工卡号
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotUserBankInfo(playload, config) {
  return request({
    url: "/api/v2/user/queryLotUserBankInfo",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 获取客户反馈信息
 *
 * @description 个人中心设置反馈列表
 *
 * @see 不在接口文档内
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryCustomerFeedbackList(playload, config) {
  return request({
    url: "/api/v2/user/queryCustomerFeedbackList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 用户反馈填写
 *
 * @description 个人中心设置用户反馈填写
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function addCustomerFeedback(playload, config) {
  return request({
    url: "/api/v2/user/addCustomerFeedback",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 绑定手机号
 *
 * @description 绑定手机号
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function updatePhone(playload, config) {
  return request({
    url: "/api/v2/user/updatePhone",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 获取手机号码验证码和重置密码
 *
 * @description 获取手机号码验证码和重置密码
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function smsYunXinPhone(playload, config) {
  return request({
    url: "/api/v2/user/smsYunXinPhone",
    method: "POST",
    data: playload,
    ...config
  });
}
/**
 * 修改（增加）真实姓名
 *
 * @description 修改（增加）真实姓名
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function updateName(playload) {
  return request({
    url: "/api/v2/user/updateName",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 用户新增修改昵称接口
 *
 * @description 用户新增修改昵称接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function updateNickName(playload, config) {
  return request({
    url: "/api/v2/user/updateNickName",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 用户密码管理接口
 *
 * @description 用户密码修改
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function modifyPassword(playload) {
  return request({
    url: "/api/v2/user/modifyPassword",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 用户资金密码设置或修改
 *
 * @description 设置资金密码
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function setPayPwd(playload) {
  return request({
    url: "/api/v2/user/setPayPwd",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 判断用户是否设置资金密码接口
 *
 * @description 判断用户是否设置资金密码
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getUserPayPwd(playload, config = {}) {
  return request({
    url: "/api/v2/user/getUserPayPwd",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 充值列表和详情
 *
 * @description 查询充值列表和详情
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRechargeList(playload) {
  return request({
    url: "/api/v2/user/queryRechargeList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 查询账户(个人中心余额)
 *
 * @description 用户登录
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBalance(playload) {
  return request({
    url: "/api/v2/user/queryBalance",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取支付类型
 *
 * @description 获取支付类型
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getUsablePayType(playload = {}, config) {
  return request({
    url: "/api/v2/user/getUsablePayType",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 充值
 *
 * @description 用户充值
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function recharge2(playload, config) {
  return request({
    url: "/api/v2/user/getWalletInfo",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 充值
 *
 * @description 用户充值
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function recharge(playload, config) {
  return request({
    url: "/api/v2/user/recharge",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 设置用户头像
 *
 * @description 获取头像列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function updateUserImg(playload, config) {
  return request({
    url: "/api/v2/user/updateUserImg",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 提现列表和详情
 *
 * @description 查询提现列表和详情，只有提现到卡这种模式
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryTakeFeeList(playload) {
  return request({
    url: "/api/v2/user/queryTakeFeeList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 用户提现
 *
 * @description 用户提现申请
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function takeFee(playload, config) {
  return request({
    url: "/api/v2/user/takeFee",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 用户充值提现
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 */
export async function handsfeeRecharge(playload, config) {
  return request({
    url: "api/v2/user/handsfeeRecharge",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: false,
    ...config
  });
}

/**
 * 同意余额宝协议接口 (加密接口)
 *
 * @description 同意余额宝协议接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function agreeYeb(playload, config) {
  return request({
    url: "/api/v2/conduct/agreeYeb",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 余额宝转入转出接口(加密接口)
 *
 * @description 余额宝转入转出接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function yebTransform(playload, config) {
  return request({
    url: "/api/v2/conduct/yebTransform",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 获取余额宝明细接口
 *
 * @description 获取余额宝明细接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryYebTradeList(playload) {
  return request({
    url: "/api/v2/conduct/queryYebTradeList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取用户余额宝近七天利息收益情况接口
 *
 * @description 获取用户余额宝近七天利息收益情况接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryUserYebInterest(playload) {
  return request({
    url: "/api/v2/conduct/queryUserYebInterest",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取余额宝主页头部收益信息接口
 *
 * @description 获取余额宝主页头部收益信息接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryUserYebInfo(playload, config) {
  return request({
    url: "/api/v2/conduct/queryUserYebInfo",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 获取用户余额与签到信息
 *
 * @description 获取用户余额与签到信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function balanceAdnSign(playload, config) {
  return request({
    url: "/api/v2/user/balanceAdnSign",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 转盘活动用户收货信息填写
 *
 * @description 转盘活动用户收货信息填写
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function userInfo(playload) {
  return request({
    url: "/api/v2/user/turntable/userInfo",
    method: "POST",
    data: playload,
    userId: true,
    loading: true
  });
}
/**
 * 抽取转盘奖品
 *
 * @description 抽取转盘奖品
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function turnTable(playload, config) {
  return request({
    url: "/api/v2/user/get/turnTable",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 获取红包活动详情信息
 *
 * @description 获取红包活动详情信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacketSetting_info(playload, config) {
  return request({
    url: "/api/v2/user/redpacketSetting/info",
    method: "POST",
    data: playload,
    noEncrypt: true,
    userId: true,
    ...config
  });
}
/**
 * 获取我的转盘活动奖品信息
 *
 * @description 获取我的转盘活动奖品信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function myPrize(playload) {
  return request({
    url: "/api/v2/user/turntable/myPrize",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 红包提现
 *
 * @description 红包提现
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacket_take(playload, config) {
  return request({
    url: "/api/v2/user/redpacket/take",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 获取转盘中奖列表信息
 *
 * @description 获取转盘中奖列表信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function turntable_pattern(playload, config) {
  return request({
    url: "/api/v2/user/turntable/pattern",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 获取试玩账号接口
 *
 * @description 获取试玩账号接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getPlayAccount(playload) {
  return request({
    url: "/api/v2/user/getPlayAccount",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}

/**
 * 用户推广码列表接口
 *
 * @description 用户推广码列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryUserExpandList(playload, config) {
  return request({
    url: "/api/v2/user/queryUserExpandList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 生成用户随机推广码接口
 *
 * @description 生成用户随机推广码接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function randomExpand(playload) {
  return request({
    url: "/api/v2/user/randomExpand",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 用户推广码添加接口
 *
 * @description 用户推广码添加接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function addExpand(playload, config) {
  return request({
    url: "/api/v2/user/addExpand",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 用户推广码修改接口
 *
 * @description 用户推广码修改接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function modifyExpand(playload, config) {
  return request({
    url: "/api/v2/user/modifyExpand",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 用户推广码删除接口
 *
 * @description 用户推广码删除接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function deleteExpand(playload) {
  return request({
    url: "/api/v2/user/deleteExpand",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 账户明细接口
 *
 * @description 获取账户明细列表信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBalanceDetailList(playload) {
  return request({
    url: "/api/v2/user/queryBalanceDetailList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取用户红包列表信息
 *
 * @description 获取用户红包列表信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacket_me(playload, config) {
  return request({
    url: "/api/v2/user/redpacket/me",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}
/**
 * 获取红包排行榜列表信息
 *
 * @description 获取红包排行榜列表信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacket_pattern(playload, config) {
  return request({
    url: "/api/v2/user/redpacket/pattern",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 抽取红包
 *
 * @description 抽取红包
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function get_redpacket(playload, config) {
  return request({
    url: "/api/v2/user/get/redpacket",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 查询红包状态(不加密)
 *
 * @description 查询红包状态(不加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacketStatus(playload) {
  return request({
    url: "/api/v2/user/redpacketStatus",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 红包列表(不加密)
 *
 * @description 红包列表(不加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacketList(playload) {
  return request({
    url: "/api/v2/user/redpacketList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 抢红包(加密)
 *
 * @description 抢红包(加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function receiveRedpacket(playload) {
  return request({
    url: "/api/v2/user/receiveRedpacket",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 用户签到
 *
 * @description 用户签到
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function sign(playload, config) {
  return request({
    url: "/api/v2/user/sign",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}
/**
 * 发红包(加密)
 *
 * @description 发红包(加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function sendRedpacket(playload) {
  return request({
    url: "/api/v2/user/sendRedpacket",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 获取红包配置信息(不加密)
 *
 * @description 获取红包配置信息(不加密)
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function redpacketChatConfig(playload) {
  return request({
    url: "/api/v2/user/redpacketChatConfig",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 聊天室盈利排行榜
 *
 * @description 聊天室盈利排行榜
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function rankOfProfit(playload) {
  return request({
    url: "/api/v2/user/rankOfProfit",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 聊天室充值排行榜
 *
 * @description 聊天室充值排行榜
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function rankOfRecharge(playload) {
  return request({
    url: "/api/v2/user/rankOfRecharge",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 获取未领取红包
 *
 * @description 获取未领取红包
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryUnclaimedRedpacket(playload) {
  return request({
    url: "/api/v2/user/queryUnclaimedRedpacket",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}

/**
 * 获取用户消息
 *
 * @description 获取用户消息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryUserMessage(playload) {
  return request({
    url: "/api/v2/user/queryUserMessage",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 获取登录用户会员公告、系统公告未读数量
 *
 * @description 获取登录用户会员公告、系统公告未读数量
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function isqueryUserMessage(playload) {
  return request({
    url: "/api/v2/user/isqueryUserMessage",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 查询可以绑定到邀请码的平台
 *
 * @description 查询绑定要邀请码的可用平台列表（不加密，需要登录）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryExpandPlatformType(playload) {
  return request({
    url: "/api/v2/user/queryExpandPlatformType",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 用户登录接口
 *
 * @description 用户登录接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function login(playload, config) {
  return request({
    url: "/api/v2/user/login",
    method: "POST",
    data: playload,
    ...config
  });
}
/**
 * 注册提交接口
 *
 * @description 注册提交接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function register(playload, config) {
  return request({
    url: "/api/v2/user/register",
    method: "POST",
    data: playload,
    ...config
  });
}

/**
 * 银行卡绑定账号验证
 *
 * @description 账号验证
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function passWordUserCode(playload, config) {
  return request({
    url: "/api/v2/user/passWordUserCode",
    method: "POST",
    data: playload,
    ...config
  });
}

/**
 * @see lottery接口设计文档
 *
 * @description 重置登录密码
 *
 * @param playload
 * @param config
 * @return {Promise<void>}
 */
export async function resetLoginPwd(playload, config) {
  return request({
    url: "/api/v2/user/resetLoginPwd",
    method: "POST",
    data: playload,
    ...config
  });
}
/**
 * @description 解绑银行卡
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 */

export async function unBindBank(playload, config) {
  return request({
    url: "/api/v2/user/unBindBank",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: false,
    ...config
  });
}

/**
 * 用户登出接口
 *
 * @description 用户登出接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function loginOut(playload, config) {
  return request({
    url: "/api/v2/user/loginOut",
    method: "POST",
    data: playload,
    ...config
  });
}

/**
 *
 * @description  * 获取礼包中心活动列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getGiftCenterActivityList(playload) {
  return request({
    url: "api/v2/user/activity/courtesy",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}

/**
 *
 * @description  * 获取礼包中心子任务列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getGiftCenterSubActList(playload) {
  return request({
    url: "api/v2/user/courtesy/getDetail",
    method: "POST",
    data: playload,
    noEncrypt: true,
    loading: true
  });
}

/**
 *
 * @description  * 礼包中心领取彩金
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function receivePrizeMoney(playload, config) {
  return request({
    url: "api/v2/user/get/courtesy",
    method: "POST",
    data: playload,
    ...config,
    loading: true
  });
}

/**
 * @description 获取今日战绩
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效荷载
 * @return {Object} Promise
 *
 * @since 2.0.0
 */

export async function getTodayBetWin(playload, config) {
  return request({
    url: "api/v2/betShare/getTodayBetWin",
    method: "POST",
    data: playload,
    ...config,
    loading: true
  });
}

/**
 * @description 登录历史
 * @param playload
 * @param config
 * @return {Promise<void>}
 */
export async function getUserLoginLog(playload = {}) {
  return request({
    url: "api/v2/user/findUserLoginLog",
    method: "POST",
    data: playload,
    noEncrypt: true,
    loading: true,
    userId: true
  });
}

/**
 * 充值、盈利、佣金排行榜
 * @param playload
 * @return {Promise<void>}
 */
export async function getUserChatRank(playload = {}) {
  return request({
    url: "api/v2/user/userChatRank",
    method: "POST",
    data: playload,
    noEncrypt: true,
    loading: true,
    userId: false
  });
}

export async function queryUserInfo(playload = {}) {
  return request({
    url: "api/v2/user/queryUserInfo",
    method: "POST",
    data: playload,
    noEncrypt: true,
    loading: true,
    userId: true
  });
}

export async function queryFavoritesList(playload = {}) {
  return request({
    url: "api/v2/lotUserFavorites/favoritesList",
    method: "POST",
    data: playload,
    noEncrypt: false,
    loading: true,
    userId: true
  });
}

export async function saveFavoritesList(playload = {}) {
  return request({
    url: "api/v2/lotUserFavorites/save",
    method: "POST",
    data: playload,
    noEncrypt: false,
    loading: true,
    userId: true
  });
}

export async function deleteFavoritesList(playload = {}) {
  return request({
    url: "api/v2/lotUserFavorites/delete",
    method: "POST",
    data: playload,
    noEncrypt: false,
    loading: true,
    userId: true
  });
}

export async function verifyDigiccy(playload, config) {
  return request({
    url: "/api/v2/user/verifyDigiccy",
    method: "POST",
    data: playload,
    noEncrypt: false,
    userId: true,
    ...config
  });
}

export async function queryCurrencyExchangeInfo(playload = {}, config) {
  return request({
    url: "/api/v2/user/queryCurrencyExchangeInfo",
    method: "POST",
    userId: false,
    noEncrypt: true,
    ...config
  });
}

export async function queryCurrencyExchangeByScur(playload = {}, config) {
  return request({
    url: "/api/v2/user/queryCurrencyExchangeByScur",
    method: "POST",
    data: playload,
    userId: false,
    noEncrypt: true,
    ...config
  });
}

export async function queryLotUserCodeQuantity(playload, config) {
  return request({
    url: "/api/v2/user/queryLotUserCodeQuantity",
    method: "POST",
    data: playload,
    noEncrypt: false,
    userId: true,
    ...config
  });
}

export async function queryStatsModuleTeamCount(data, config) {
  return request({
    url: "/stats/queryStatsModuleTeamCount",
    method: "POST",
    data,
    noEncrypt: true,
    userId: true,
    ...config
  });
}

export async function downappurl(data, config) {
  return request({
    url: "/api/v2/appurl",
    method: "GET",
    params: data,
    noEncrypt: false,
    userId: false,
    ...config
  });
}

export async function sendCodeForWallet(playload, config) {
  return request({
    url: "/api/v2/user/sendCodeForWallet",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

export async function bindWallet(playload, config) {
  return request({
    url: "/api/v2/user/bindWallet",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

export async function unbindWallet(playload, config) {
  return request({
    url: "/api/v2/user/unbindWallet",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

export async function getUserSignMonth(playload) {
  return request({
    url: "/api/v2/user/getUserSignMonth",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
